var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-row",
    {
      staticClass: "pa-2",
      attrs: { "no-gutters": "", justify: "end", align: "center" },
    },
    [
      _vm._t("default"),
      !_vm.isViewsSettingsHidden
        ? _c(
            "v-menu",
            {
              attrs: {
                "offset-y": "",
                "disable-keys": "",
                "close-on-content-click": false,
                "min-width": "500",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "v-btn",
                          _vm._g(
                            _vm._b(
                              {
                                attrs: { icon: "", loading: _vm.viewsLoading },
                              },
                              "v-btn",
                              attrs,
                              false
                            ),
                            on
                          ),
                          [
                            _vm.activeViewKey
                              ? _c(
                                  "v-badge",
                                  {
                                    attrs: {
                                      left: "",
                                      overlap: "",
                                      content: "!",
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-cog-outline")])],
                                  1
                                )
                              : _c("v-icon", [_vm._v("mdi-cog-outline")]),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                2603065765
              ),
            },
            [
              _c(
                "v-list",
                [
                  _c(
                    "v-overlay",
                    { attrs: { absolute: true, value: _vm.viewsLoading } },
                    [
                      _c("v-progress-circular", {
                        staticClass: "mb-0",
                        attrs: { indeterminate: "", color: "primary" },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-container",
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "", justify: "center" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { small: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.changeToolbarViewsTab(null)
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.isViewsShown ? "Cancel" : "New View"
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-container",
                    [
                      !_vm.isViewsShown
                        ? _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-radio-group",
                                        {
                                          attrs: {
                                            "hide-details": "",
                                            value: _vm.activeViewKey,
                                          },
                                          on: { change: _vm.changeActiveView },
                                        },
                                        [
                                          _c(
                                            "v-list-item",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-col",
                                                { attrs: { cols: "12" } },
                                                [
                                                  _c(
                                                    "v-row",
                                                    { attrs: { dense: "" } },
                                                    [
                                                      _c("v-radio", {
                                                        staticClass: "mb-0",
                                                        attrs: {
                                                          label: "Default View",
                                                          value: 0,
                                                        },
                                                      }),
                                                      _c(
                                                        "sub",
                                                        {
                                                          staticClass:
                                                            "grey--text",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " (" +
                                                              _vm._s(
                                                                _vm.headers
                                                                  .length
                                                              ) +
                                                              ") "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "v-list-item",
                                            { attrs: { dense: "" } },
                                            [_c("v-divider")],
                                            1
                                          ),
                                          _vm._l(
                                            _vm.viewsList,
                                            function (viewItem, viewIndex) {
                                              return _c(
                                                "v-list-item",
                                                {
                                                  key: viewIndex,
                                                  attrs: { dense: "" },
                                                },
                                                [
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "8" } },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: { dense: "" },
                                                        },
                                                        [
                                                          _c("v-radio", {
                                                            staticClass: "mb-0",
                                                            attrs: {
                                                              label: `${viewItem.name}`,
                                                              value:
                                                                viewItem.key,
                                                            },
                                                          }),
                                                          _c(
                                                            "sub",
                                                            {
                                                              staticClass:
                                                                "grey--text",
                                                            },
                                                            [
                                                              _vm._v(
                                                                " (" +
                                                                  _vm._s(
                                                                    viewItem
                                                                      .columns
                                                                      .length
                                                                  ) +
                                                                  ") "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    { attrs: { cols: "4" } },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        {
                                                          attrs: {
                                                            dense: "",
                                                            justify: "end",
                                                          },
                                                        },
                                                        [
                                                          _c("v-divider", {
                                                            staticClass: "mx-2",
                                                            attrs: {
                                                              vertical: "",
                                                            },
                                                          }),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              staticClass:
                                                                "mx-2",
                                                              attrs: {
                                                                small: "",
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.changeToolbarViewsTab(
                                                                      viewItem
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("v-icon", [
                                                                _vm._v(
                                                                  "mdi-pencil"
                                                                ),
                                                              ]),
                                                            ],
                                                            1
                                                          ),
                                                          _c(
                                                            "v-btn",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                icon: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.removeStoredView(
                                                                      viewItem.key
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-icon",
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "red",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "mdi-trash-can-outline"
                                                                  ),
                                                                ]
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            }
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "v-row",
                            [
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-list-item",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          autofocus: "",
                                          label: "New view name",
                                        },
                                        model: {
                                          value: _vm.editViewName,
                                          callback: function ($$v) {
                                            _vm.editViewName = $$v
                                          },
                                          expression: "editViewName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.editViewColumns.length > 0,
                                            "open-delay": "250",
                                            top: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "primary",
                                                              disabled:
                                                                !_vm.editViewName ||
                                                                _vm
                                                                  .editViewColumns
                                                                  .length <= 0,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.saveEditView(
                                                                  false
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [_vm._v(" Save ")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            209672267
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("At least one column"),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-tooltip",
                                        {
                                          attrs: {
                                            disabled:
                                              _vm.editViewColumns.length > 0 ||
                                              _vm.editViewKey ===
                                                _vm.activeViewKey,
                                            "open-delay": "250",
                                            top: "",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "span",
                                                      _vm._g(
                                                        _vm._b(
                                                          {},
                                                          "span",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                              color: "primary",
                                                              disabled:
                                                                !_vm.editViewName ||
                                                                _vm.editViewKey ===
                                                                  _vm.activeViewKey ||
                                                                _vm
                                                                  .editViewColumns
                                                                  .length <= 0,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.saveEditView(
                                                                  true
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Save & active "
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            837643623
                                          ),
                                        },
                                        [
                                          _c("span", [
                                            _vm._v("At least one column"),
                                          ]),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    { attrs: { dense: "" } },
                                    [_c("v-divider")],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { small: "" },
                                          on: {
                                            click: function ($event) {
                                              _vm.editViewColumns = []
                                            },
                                          },
                                        },
                                        [_vm._v(" Clear all ")]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { small: "" },
                                          on: { click: _vm.setEditViewCols },
                                        },
                                        [_vm._v(" Choose all ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                [
                                  _c(
                                    "v-list",
                                    {
                                      staticClass: "overflow-y-auto",
                                      attrs: { "max-height": "600" },
                                    },
                                    _vm._l(_vm.headers, function (headerItem) {
                                      return _c(
                                        "v-list-item",
                                        {
                                          key: headerItem.value,
                                          attrs: { dense: "" },
                                        },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              dense: "",
                                              "hide-details": "",
                                              label: headerItem.text,
                                              "input-value":
                                                _vm.editViewColumns.includes(
                                                  headerItem.value
                                                ),
                                              disabled:
                                                _vm.preparedHeaders.length -
                                                  1 ===
                                                  0 &&
                                                _vm.preparedHeaders.includes(
                                                  headerItem.value
                                                ),
                                            },
                                            on: {
                                              change: function ($event) {
                                                return _vm.changeNewViewHeader(
                                                  $event,
                                                  headerItem.value
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.filtersCount
        ? _c(
            "v-tooltip",
            {
              attrs: { "open-delay": "250", top: "" },
              scopedSlots: _vm._u(
                [
                  {
                    key: "activator",
                    fn: function ({ on, attrs }) {
                      return [
                        _c(
                          "span",
                          _vm._g(_vm._b({}, "span", attrs, false), on),
                          [
                            _c(
                              "v-btn",
                              {
                                staticClass: "mx-1",
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.$emit("reset-filters")
                                  },
                                },
                              },
                              [
                                _c(
                                  "v-badge",
                                  {
                                    attrs: {
                                      left: "",
                                      overlap: "",
                                      content: _vm.filtersCount,
                                    },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-filter-remove")])],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                2521947284
              ),
            },
            [_c("span", [_vm._v("Reset filters")])]
          )
        : _vm._e(),
      _c(
        "v-tooltip",
        {
          attrs: { "open-delay": "250", top: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "span",
                    _vm._g(_vm._b({}, "span", attrs, false), on),
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mx-1",
                          attrs: {
                            icon: "",
                            loading: _vm.gridDataLoading,
                            disabled: _vm.gridDataLoading,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("refresh")
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-cached")])],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Refresh")])]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }